/**
 * GA4-specific marketing utilities
 * GTM의 dataLayer를 통해 이벤트를 전송합니다.
 */
import { getMarketingParamsWithSource } from './client'
import type { MarketingParamsResult } from './types'

/**
 * Get marketing parameters formatted for GA4 events
 * Includes automatic source normalization
 */
export function getGA4MarketingParams(): MarketingParamsResult {
  return getMarketingParamsWithSource()
}

/**
 * Send a GA4 event with marketing context via GTM dataLayer
 */
export function sendGA4EventWithMarketing(eventName: string, eventParams = {}): void {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return
  }

  const marketingParams = getGA4MarketingParams()

  window.dataLayer.push({
    event: eventName,
    ...eventParams,
    ...marketingParams,
  })
}

/**
 * Send a GA4 pageview with marketing context via GTM dataLayer
 */
export function sendGA4PageViewWithMarketing(pagePath: string, pageTitle?: string): void {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return
  }

  const marketingParams = getGA4MarketingParams()

  window.dataLayer.push({
    event: 'page_view',
    page_path: pagePath,
    page_title: pageTitle,
    ...marketingParams,
  })
}

/**
 * Track a conversion with marketing attribution via GTM dataLayer
 */
export function trackGA4Conversion(conversionLabel: string, conversionValue?: number, additionalParams?: object): void {
  sendGA4EventWithMarketing('conversion', {
    conversion_label: conversionLabel,
    value: conversionValue,
    ...additionalParams,
  })
}
